export const getInputType = (key, operator, filterTypes) => {
  if (key === 'created_at' || key === 'last_activity_at')
    if (operator === 'days_before') return 'plain_text';
  const type = filterTypes.find(filter => filter.attributeKey === key);
  return type?.inputType;
};

export const generateCustomAttributesInputType = type => {
  const filterInputTypes = {
    text: 'string',
    number: 'string',
    date: 'string',
    checkbox: 'multi_select',
    list: 'multi_select',
    link: 'string',
  };
  return filterInputTypes[type];
};

export const getAttributeInputType = (key, allCustomAttributes) => {
  const customAttribute = allCustomAttributes.find(
    attr => attr.attribute_key === key
  );
  const { attribute_display_type } = customAttribute;
  const filterInputTypes = generateCustomAttributesInputType(
    attribute_display_type
  );
  return filterInputTypes;
};

export const getValuesName = (values, list, idKey, nameKey) => {
  const item = list?.find(v => {
    // Try both string and number comparison
    const listValue = v[idKey];
    const searchValue = values[0];
    return listValue === searchValue || 
           listValue === String(searchValue) || 
           listValue === Number(searchValue) ||
           String(listValue) === String(searchValue);
  });
  return {
    id: values[0],
    name: item ? item[nameKey] : values[0],
  };
};

export const getValuesForStatus = values => {
  return values.map(value => ({ id: value, name: value }));
};

const getValuesForLabels = (values, labels) => {
  const selectedLabels = labels.filter(label => values.includes(label.title));
  return selectedLabels.map(({ title }) => ({
    id: title,
    name: title,
  }));
};

const getValuesForLanguages = (values, languages) => {
  const selectedLanguages = languages.filter(language =>
    values.includes(language.id)
  );
  return selectedLanguages.map(({ id, name }) => ({
    id: id.toLowerCase(),
    name: name,
  }));
};

const getValuesForCountries = (values, countries) => {
  const selectedCountries = countries.filter(country =>
    values.includes(country.id)
  );
  return selectedCountries.map(({ id, name }) => ({
    id: id,
    name: name,
  }));
};

export const getValuesForFilter = (filter, params) => {
  const { attribute_key, values } = filter;
  const {
    languages,
    countries,
    agents,
    states,
    inboxes,
    teams,
    campaigns,
    labels,
    boards,
  } = params;
  switch (attribute_key) {
    case 'status':
      return getValuesForStatus(values);
    case 'assignee_id':
      return getValuesName(values, agents, 'id', 'name');
    case 'state_id':
      return getValuesName(values, states, 'id', 'name');
    case 'inbox_id':
      return getValuesName(values, inboxes, 'id', 'name');
    case 'team_id':
      return getValuesName(values, teams, 'id', 'name');
    case 'campaign_id': {
      // For campaign_id, we need to return the full campaign object including statuses_attributes
      // so the status dropdown can be populated
      const campaign = campaigns?.find(c => {
        return c.id === values[0] || 
               c.id === String(values[0]) || 
               c.id === Number(values[0]) ||
               String(c.id) === String(values[0]);
      });
      return campaign ? {
        id: campaign.id,
        name: campaign.name,
        statuses_attributes: campaign.statuses_attributes,
      } : { id: values[0], name: values[0] };
    }
    case 'labels': {
      return getValuesForLabels(values, labels);
    }
    case 'labels_id': {
      // For contact filters, labels_id uses id instead of title
      return getValuesName(values, labels, 'id', 'name');
    }
    case 'board_id': {
      // For board_id, we need to return the full board object including statuses_attributes
      // so the pipeline dropdown can be populated
      const board = boards?.find(b => {
        return b.id === values[0] || 
               b.id === String(values[0]) || 
               b.id === Number(values[0]) ||
               String(b.id) === String(values[0]);
      });
      return board ? {
        id: board.id,
        name: board.name,
        statuses_attributes: board.statuses_attributes,
      } : { id: values[0], name: values[0] };
    }
    case 'browser_language': {
      return getValuesForLanguages(values, languages);
    }
    case 'country_code': {
      return getValuesForCountries(values, countries);
    }
    default:
      return { id: values[0], name: values[0] };
  }
};

export const generateValuesForEditCustomViews = (filter, params) => {
  const { attribute_key, filter_operator, values } = filter;
  const { filterTypes, allCustomAttributes } = params;
  const inboxType = getInputType(attribute_key, filter_operator, filterTypes);

  if (inboxType === undefined) {
    const filterInputTypes = getAttributeInputType(
      attribute_key,
      allCustomAttributes
    );
    return filterInputTypes === 'string'
      ? values[0].toString()
      : { id: values[0], name: values[0] };
  }

  return inboxType === 'multi_select' || inboxType === 'search_select'
    ? getValuesForFilter(filter, params)
    : values[0].toString();
};
